import { useEffect, useRef } from 'react'
import { useLocation, useNavigation } from 'react-router'

export const useViewTransition = () => {
  const navigation = useNavigation()
  const location = useLocation()

  const isTransitioning = useRef(false)
  const previousPathname = useRef(location.pathname)
  const transitionResolve = useRef<(() => void) | null>(null)

  useEffect(() => {
    if (typeof document === 'undefined') return
    if (!('startViewTransition' in document)) return

    if (navigation.state === 'loading' && !isTransitioning.current) {
      const targetPath = navigation.location?.pathname
      if (targetPath && targetPath !== previousPathname.current) {
        isTransitioning.current = true

        const transition = (document as any).startViewTransition(() => {
          return new Promise<void>((resolve) => {
            transitionResolve.current = resolve
          })
        })

        // Skipped animations reject ready even when the navigation update succeeds.
        transition.ready.catch(() => {})

        transition.finished.finally(() => {
          isTransitioning.current = false
          transitionResolve.current = null
          previousPathname.current = targetPath
        })
      }
    }

    if (navigation.state === 'idle' && transitionResolve.current) {
      transitionResolve.current()
      transitionResolve.current = null
    }
  }, [navigation.state, navigation.location, location.pathname])
}
